/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryResponse,
  GetApiV1IndividualpaymentParcelsParcelidInvoicesPathParams,
  GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryParams,
  GetApiV1IndividualpaymentParcelsParcelidInvoices401,
  GetApiV1IndividualpaymentParcelsParcelidInvoices500,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentParcelsParcelidInvoices.ts";

function getGetApiV1IndividualpaymentParcelsParcelidInvoicesUrl(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidInvoicesPathParams["parcelId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/parcels/${parcelId}/invoices` as const,
  };
  return res;
}

/**
 * @description Retorna as NFes da parcela com status, texto do status, última observação registrada e dados de RPS, ordenadas pela data de competência. Migrado do legado IndividualPayment/LoadGridDataAsyncInvoices. **(Requer Authorization para autenticação)**
 * @summary Retorna as notas fiscais (eNotas) de uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/invoices}
 */
export async function getApiV1IndividualpaymentParcelsParcelidInvoices(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidInvoicesPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidInvoices401
      | GetApiV1IndividualpaymentParcelsParcelidInvoices500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentParcelsParcelidInvoicesUrl(
      parcelId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
